var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconPresent128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_20914)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7445 20.5029C101.91 20.5029 102.979 30.613 103 34.7808L103 35.1558C102.999 35.7444 102.989 36.4659 102.875 37.2721C102.577 39.3839 101.567 42.0783 98.1464 44.5027L30.8543 44.5029C27.4336 42.0785 26.4228 39.3842 26.1246 37.2724L26.1249 37.2707L26.0823 36.9319C26.0086 36.2624 26.0008 35.6603 26 35.1558L26 34.9118C26 30.8293 26.95 20.5029 40.2555 20.5029C48.1001 20.5029 54.9535 27.7527 59.2575 33.703C60.7579 32.9352 62.4572 32.5031 64.2574 32.5031C66.2 32.5031 68.025 33.0059 69.6092 33.8885C73.9035 27.9052 80.8184 20.5029 88.7445 20.5029Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.999 32.5029C70.0752 32.5029 75 37.4281 75 43.5028C75 43.8399 74.9848 44.1735 74.9551 44.5029H53.0449C53.0152 44.1735 53 43.8399 53 43.5028C53 37.4281 57.9248 32.5029 63.999 32.5029Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9969 60.5029H106.003C107.106 60.5029 108 59.6089 108 58.506V46.4999C108 45.397 107.106 44.5029 106.003 44.5029H21.9969C20.8941 44.5029 20 45.397 20 46.4999V58.506C20 59.6089 20.8941 60.5029 21.9969 60.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9969 108.503H102.003C103.106 108.503 104 107.609 104 106.506V60.5029H24V106.506C24 107.609 24.8941 108.503 25.9969 108.503Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 91.2417L55.9867 95.5007C55.9772 95.5057 55.9654 95.502 55.9603 95.4924C55.9583 95.4885 55.9577 95.4841 55.9584 95.4798L57.4888 86.4593L51.0059 80.0709C50.9982 80.0633 50.998 80.0508 51.0055 80.043C51.0085 80.0399 51.0125 80.0378 51.0167 80.0372L59.9758 78.7211L63.9825 70.5139C63.9873 70.5042 63.999 70.5001 64.0086 70.505C64.0125 70.5069 64.0156 70.51 64.0175 70.5139L68.0242 78.7211L76.9833 80.0372C76.9939 80.0388 77.0013 80.0488 76.9998 80.0596C76.9992 80.0639 76.9972 80.0679 76.9941 80.0709L70.5112 86.4593L72.0416 95.4798C72.0434 95.4906 72.0363 95.5008 72.0257 95.5026C72.0214 95.5034 72.0171 95.5027 72.0133 95.5007L64 91.2417Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_20914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconPresent128);
export default __webpack_public_path__ + "static/media/pictogramBeaconPresent128.102cc7195ffce310bf459d56f2b219b9.svg";
export { ForwardRef as ReactComponent };